export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9367.0cbf26e1.jpg";